import slick from 'slick-carousel';
theme.ThemeSlick = function () {



	function themeSlick() {


			$('[data-slick]').each(function (index) {
				var $carousel = $(this);

				if (!$carousel.hasClass('slick-slider')) {


					$carousel.slick();
					$carousel.on('afterChange', function (slick, currentSlide) {


						$carousel.slick('setPosition');
					});
				}
			});

			$('[data-slick-pc]').each(function (index) {
				var $carousel = $(this);
				if ($(window).width() < 1025) {
					if ($carousel.length) {
						if ($carousel.hasClass('slick-slider')) {
							$carousel.slick('unslick');
						}
					}
				}
			});

			if ($(window).width() > 1024) {
				$('[data-section-type="product-list"]').each(function (index) {
					var $arrow = $(this).find('.slick-arrow');
					var $height = ($(this).find('.product-card__image').height() / 2) - 15;
					if ($arrow.length) {
						$arrow.css('top', $height);
					}
				});
			}

	}


	return {
		init: function () {
			themeSlick();
		}
	}
};

export default theme.ThemeSlick;
